<template>
    <EditModelLayout
        :indexRoute="$route('admin::profile.edit')"
        :updateRoute="$route('admin::profile.update')"
        :modelNameSingular="__('admin::admins.profile')"
        :modelNamePlural="__('admin::admins.my_profile')"
        :form="form"
        :name="form.name"
    >

        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.email')" :error="errors.email">
            <Input name="email" type="email" :has-error="exists(errors.email)" v-model="form.email" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.password')" :error="errors.password">
            <Input name="password" type="password" :has-error="exists(errors.password)" v-model="form.password" :required="false" />
        </FormGroup>

        <FormGroup :error="errors.receives_time_tracking_notifications">
            <Toggle name="receives_time_tracking_notifications" :label="__('admin::labels.receives_time_tracking_notifications')" :has-error="exists(errors.receives_time_tracking_notifications)" v-model:checked="form.receives_time_tracking_notifications" />
        </FormGroup>

    </EditModelLayout>
</template>

<script>
export default {
    props: {
        errors: Object,
        user: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                name: this.user.name,
                email: this.user.email,
                password: '',
                receives_time_tracking_notifications: this.user.receives_time_tracking_notifications,
            })
        }
    },
}
</script>
